import styled from 'styled-components';
import { colors, r8 } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { t, type I18nLocale } from '@ardoq/i18n';
import { DocumentItemViewModel } from '../assistantDocumentsOperations';
import { DocumentPreview } from './DocumentPreview';

const ChipButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: ${r8};

  &:hover,
  &:focus-visible {
    background-color: ${colors.surfaceHover};
  }
`;

type DocumentDownloadChipProps = {
  item: DocumentItemViewModel;
  i18nLocale: I18nLocale;
  onDownload: VoidFunction;
};

export const DocumentDownloadChip = ({
  item,
  i18nLocale,
  onDownload,
}: DocumentDownloadChipProps) => (
  <ChipButton
    type="button"
    onClick={onDownload}
    aria-label={t(
      i18nLocale,
      'assistant:documents.downloadDocument',
      'Download document'
    )}
  >
    <FlexBox
      align="center"
      gap="small"
      padding="small"
      borderColor="borderSubtle"
      borderWidth={1}
      borderRadius="r8"
    >
      <DocumentPreview item={item} />
    </FlexBox>
  </ChipButton>
);
